import React, { useContext } from "react";
import PropTypes from "prop-types";

import { LocationTypesTable } from "../../../../components/Locations";

import { ModalContext } from "../../../../components/ModalProvider";

const Types = ({ locationRecId }) => {
  const { setModalOpen } = useContext(ModalContext);
  return <LocationTypesTable id={locationRecId} setModalOpen={setModalOpen} />;
};
Types.propTypes = {
  locationRecId: PropTypes.number.isRequired
};
export default Types;
